import { withStyles } from '@material-ui/core';

import Label from './component';
import styles from './styles';

export default withStyles(styles)(Label);
